import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import ExpertCard from "@/components/ExpertCard";

export default function Matches() {
  const { problemId } = useParams();
  const [problem, setProblem] = useState(null);
  const [experts, setExperts] = useState([]);

  useEffect(() => {
    api.get(`/problems/${problemId}`).then(async (r) => {
      setProblem(r.data);
      const { data } = await api.post("/experts/recommend", { category_id: r.data.category_id, description: r.data.description });
      setExperts(data);
    });
  }, [problemId]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
      {problem && (
        <div className="card-outline p-5 mb-8">
          <div className="font-mono text-xs uppercase tracking-widest text-brand-muted">Dit problem</div>
          <div className="mt-1 font-display font-semibold text-brand-ink">{problem.title}</div>
          <p className="mt-1 text-brand-body text-sm">{problem.description}</p>
        </div>
      )}
      <h1 className="text-3xl font-bold text-brand-ink">{experts.length} anbefalede eksperter</h1>
      <p className="mt-1 text-brand-body">Baseret på din kategori, online-status og anmeldelser.</p>
      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {experts.map((e) => <ExpertCard key={e.id} expert={{ ...e, id: e.id }}/>)}
      </div>
      <div className="mt-8"><Link to="/eksperter" className="link-underline text-brand-ink">Se alle eksperter →</Link></div>
    </div>
  );
}

